/**
 * समीक्षा — "Review all work" (N-PAC, 4 Nov 2026): the candidate's viewer login opens the whole dashboard inside
 * the app, read-only — every module the candidate has taken, as the web shows it. The web app signs in with
 * the token the app passes in the address's fragment (never sent to a server).
 */
import { useMemo } from "react";
import { webBaseUrl } from "../platform/config";
import { useApp, useSession } from "../ui/context";
import { Banner } from "../ui/components";

export function ReviewScreen() {
  const { app, t } = useApp();
  const { assemblyId } = useSession();
  const url = useMemo(() => {
    if (!assemblyId || !app.token) return null;
    return `${webBaseUrl()}/a/${encodeURIComponent(assemblyId)}?embed=1#token=${encodeURIComponent(app.token)}`;
  }, [assemblyId, app.token]);
  if (!url) return <Banner kind="info">{t.rvNoAssembly}</Banner>;
  return (
    <div className="review" data-testid="review">
      <div className="review-bar">
        <span>👁 {t.rvTitle}</span>
        <a href={url} target="_blank" rel="noopener noreferrer" className="review-open">
          {t.rvOpenFull} ↗
        </a>
      </div>
      <iframe className="review-frame" src={url} title={t.rvTitle} allow="geolocation" />
    </div>
  );
}
